module.exports = __webpack_public_path__ + "img/f2.4af3c585.png";